import { List } from "antd";
import React from "react";
import styles from "./ListView.module.scss";
type Props = {
  renderItem: ((item: any, index: number) => React.ReactNode) | undefined;
  dataSource: any[];
  searchInput: string;
  sortFunc?: (a: any, b: any) => number;
  style?: React.CSSProperties;
};
const ListView = ({
  dataSource,
  searchInput,
  sortFunc,
  renderItem,
  style,
}: Props) => {
  return (
    <div className={styles.List} style={style ?? {}}>
      <List
        dataSource={(sortFunc
          ? [...dataSource].sort(sortFunc)
          : [...dataSource]
        ).filter(
          (
            p // Filter the search
          ) => {
            const name = p?.name || p.title;
            return name
              .toLowerCase()
              .trim()
              .includes(searchInput.toLowerCase().trim());
          }
        )}
        bordered={false}
        renderItem={renderItem}
      />
    </div>
  );
};

export default ListView;
